import { Select } from '@/design-system';

interface UserFiltersProps {
  roleFilter: string;
  isActiveFilter: boolean | undefined;
  onRoleChange: (role: string) => void;
  onActiveChange: (v: boolean | undefined) => void;
}

export function UserFilters({ roleFilter, isActiveFilter, onRoleChange, onActiveChange }: UserFiltersProps) {
  return (
    <div className="flex flex-wrap gap-3 items-end">
      <Select
        label="Perfil"
        value={roleFilter}
        onChange={(e) => onRoleChange(e.target.value)}
      >
        <option value="">Todos os perfis</option>
        <option value="SUPERADMIN">Super Admin</option>
        <option value="SUPPORT">Suporte</option>
        <option value="FINANCE">Financeiro</option>
        <option value="SALES">Vendas</option>
      </Select>
      <Select
        label="Status"
        value={isActiveFilter === undefined ? '' : isActiveFilter.toString()}
        onChange={(e) =>
          onActiveChange(e.target.value === '' ? undefined : e.target.value === 'true')
        }
      >
        <option value="">Todos</option>
        <option value="true">Ativos</option>
        <option value="false">Inativos</option>
      </Select>
    </div>
  );
}
